import { openRequestToShopModal } from "@faire/deprecated-retailer-visitor-shared/components/App/AppModals/utils";
import { Button } from "@faire/slate/components/button";
import { Column, Row } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";

interface RequestToShopSectionProps {
  onClearSearch: () => void;
  brandToken: string;
  brandName: string;
}

export const RequestToShopSection: React.FC<RequestToShopSectionProps> = ({
  onClearSearch,
  brandToken,
  brandName,
}) => {
  const history = useHistory();

  const handleRequestClick = () => {
    onClearSearch();
    openRequestToShopModal(history, brandToken, brandName);
  };

  return (
    <>
      <div className="bg-fs-expressive-surface-neutral">
        <Row className="px-4 pt-2 pb-4" align="center" justify="space-between">
          <Column gap="1x" className="flex-1">
            <Typography variant="paragraphSansMedium">
              <StrictLocalMsg
                id="xbssvq"
                defaultMessage="{brandCompanyName} isn't on Faire yet!"
                description={{
                  text: "Message indicating a specific brand is not available on Faire",
                  img: "https://cdn.faire.com/fastly/05e122abb2a117785955a15e08b13a8c192d8f748e77adbc4237b8cd009b6b6b.png",
                }}
                values={{
                  brandCompanyName: brandName,
                }}
              />
            </Typography>
            <Typography variant="paragraphSansRegular" color="subdued">
              <StrictLocalMsg
                id="Mo2Aqs"
                defaultMessage="Help get them on Faire and show your interest by requesting to shop their catalog."
                description={{
                  text: "Help text explaining how to request a brand to join Faire",
                  img: "https://cdn.faire.com/fastly/05e122abb2a117785955a15e08b13a8c192d8f748e77adbc4237b8cd009b6b6b.png",
                }}
              />
            </Typography>
          </Column>
          <Button variant="secondary" onClick={handleRequestClick}>
            <Typography>
              <StrictLocalMsg
                id="GMc1qf"
                defaultMessage="Request"
                description={{
                  text: "Button text for requesting a brand to join Faire",
                  img: "https://cdn.faire.com/fastly/05e122abb2a117785955a15e08b13a8c192d8f748e77adbc4237b8cd009b6b6b.png",
                }}
              />
            </Typography>
          </Button>
        </Row>
      </div>
    </>
  );
};
